export default "__VITE_ASSET__lvqa7jsu__"